import { useState } from "react";
import { Asset } from "../../../../models/asset"
import ToScheduleDialog from "../dialogs/toScheduleDialog";
import { useNavigate } from "react-router-dom";

interface IToScheduleProps {
    asset: Asset;
    hasMetrics?: boolean;
}
const ToSchedule = ({asset, hasMetrics}: IToScheduleProps) => {
    const navigate = useNavigate();
    const [showScheduleModal, setShowScheduleModal] = useState(false);

    return (
        <>
            <button 
                type="button" 
                // disabled={!!asset.schedulings?.next?.[0]?.date || !hasMetrics}
                onClick={() => navigate(`/fleet-manager/appointments/appointment?asset=${asset.id}&chassis=${asset.chassis}&name=${asset.name || asset.model}`)}
                // Hide the button if the asset has no volksTotalPlan (back after the volkstotal info is available)
                // onClick={() => {
                //     if(asset?.volksTotalPlan) navigate(`/fleet-manager/appointments/appointment?asset=${asset.id}`)
                //     else setShowScheduleModal(true)
                // }}
            >
                <span className={`rioglyph rioglyph-calendar active`} />
            </button>

            <ToScheduleDialog
                asset={asset}
                isOpen={showScheduleModal}
                onClose={() => setShowScheduleModal(false)}
            />
        </>
    )
}

export default ToSchedule;